import apiClient from "@/apiClient";

class VacancyService {
  async show(id) {
    const response = await apiClient.get(`/api/vacancy/${id}`);
    return response.data;
  }

  async update(id, payload) {
    const response = await apiClient.put(`/api/vacancy/${id}`, payload);
    return response.data;
  }

  async convertToStaff(id) {
    const response = await apiClient.post(`/api/vacancy/${id}/convert-to-staff`, {
      confirm: true,
    });
    return response.data;
  }

}

export default VacancyService;
